export default {
      id: "org-structure-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#org-structure-usage",
      toString: function () {
        return this.url;
      }
    }